import { useState, useEffect } from 'react';

// Custom hook for mobile detection
const getIsMobile = () => typeof window !== 'undefined' && window.innerWidth < 900;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(getIsMobile());
    };

    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return isMobile;
};

export default useIsMobile;
